import React, { Component } from 'react'
import { Header, Segment, Form, Grid, Button, Icon,Search } from 'semantic-ui-react'
import { formatDate, parseDate } from 'react-day-picker/moment';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/lib/src/DayPickerInput';

export class AddPropertyVisitInput extends Component {
  render() {
    const statusOptions = [
      {key: '0', type: 'input', text: 'Pending', value: 0},
      {key: '1', type: 'input', text: 'Scheduled', value: 1},
      {key: '2', type: 'input', text: 'Confirmed', value: 2},
      {key: '3', type: 'input', text: 'Processing', value: 3},
      {key: '4', type: 'input', text: 'Submitted', value: 4},
      {key: '5', type: 'input', text: 'Completed', value: 5},
      {key: '6', type: 'input', text: 'Cancelled', value: 6 },
      {key: '7', type: 'input', text: 'Aborted', value: 7 },    
    ]
      return (
        <Segment secondary={this.props.zebraRow? true:false}>
          <Form onSubmit={() =>{this.props.addOrDeleteVisit(this.props.arrayIndex)}}>
            <Grid divided style={{ marginTop: "0px" }}columns={6} stackable>
                <Grid.Row style={{ paddingTop: "0px" }}>
                  <Grid.Column width={5}><Form.Input required value={this.props.visitAddress} onChange={(e) =>{this.props.handleDataChange(this.props.arrayIndex,e.target.value,"address")}} label={this.props.arrayIndex == undefined || this.props.showDetails ? "Property Address" : null} /></Grid.Column>
                  <Grid.Column width={2}>
                    <Form.Field>{this.props.arrayIndex == undefined || this.props.showDetails ? <label>Company</label> : null}
                      <Search
                        loading={this.props.companyOptions.length == 0}
                        placeholder='Search...'
                        results={this.props.companyOptions.filter(company =>{return company.title.toLowerCase().includes(this.props.visitCompany.toLowerCase())})}
                        value={this.props.visitCompany} 
                        onSearchChange={(e,data) => { this.props.handleDataChange(this.props.arrayIndex,data.value,"company")}} 
                        onResultSelect={(e,data) => {this.props.handleDataChange(this.props.arrayIndex,data.result.title,"company")}} 
                        />
                     </Form.Field>
            </Grid.Column>
                <Grid.Column width={2}><Form.Field>
                  {this.props.arrayIndex == undefined || this.props.showDetails ? <label>Date {this.props.visitDate ? <span style={{ color: "red",fontWeight:600 }} onClick={() =>{this.props.handleDataChange(this.props.arrayIndex, undefined, "date")} } >CLEAR</span> :<span> - Not Set</span>}</label> : null}
                  <DayPickerInput
                            placeholder="DD-MM-YYYY"
                    dayPickerProps={{
                                todayButton: 'Clear',
                      firstDayOfWeek: 1,
                                onTodayButtonClick:(e) => {this.props.handleDataChange(this.props.arrayIndex, undefined, "date")}
                            }}
                            format="DD-MM-YYYY"
                    formatDate={formatDate}
                            parseDate={parseDate}
                    value={this.props.visitDate?this.props.visitDate:""}
                    onDayChange={day => {

                      if (day) {
                        this.props.handleDataChange(this.props.arrayIndex, day, "date")
                      }                             
                      else {
                        this.props.handleDataChange(this.props.arrayIndex, undefined, "date");
                      }}}/>
                </Form.Field>
                </Grid.Column>
                <Grid.Column width={2}><Form.Input value={this.props.visitTime} onChange={(e) => { this.props.handleDataChange(this.props.arrayIndex, e.target.value, "time") }} label={this.props.arrayIndex == undefined || this.props.showDetails ? "Time" : null} /></Grid.Column>
                <Grid.Column width={2}>{this.props.initialized && <Form.Dropdown
                  options={this.props.clerkOptions}
                  search label={this.props.arrayIndex == undefined || this.props.showDetails ? "Clerk" : null} selection fluid deburr placeholder="Select Clerk" loading={this.props.clerkOptions.length == 0} defaultValue={this.props.visitClerk ? this.props.visitClerk : 0}
                  onChange={(e, option) => {
                    this.props.handleDataChange(this.props.arrayIndex, option.value, "clerk");
                  }}
                />}
                </Grid.Column> 
                <Grid.Column width={2}>{this.props.initialized &&<Form.Dropdown
                  options={statusOptions}
                  search label={this.props.arrayIndex == undefined || this.props.showDetails ? "Status" : null} selection fluid deburr placeholder="Select Status" defaultValue={this.props.visitStatus?this.props.visitStatus:0}
                  onChange={(e,option) => {this.props.handleDataChange(this.props.arrayIndex,option.value,"status")
                  }}
                />}
                </Grid.Column> 
                {!this.props.editMode &&<Grid.Column width={1} style={{ margin: "auto", textAlign: "center" }} >{this.props.arrayIndex == undefined ? <Form.Button basic compact icon primary><Icon name="add"></Icon>Add</Form.Button> : <Form.Button basic compact icon primary size='mini' negative><Icon name="delete"></Icon>Delete</Form.Button>}</Grid.Column>}
                
              </Grid.Row>
              {this.props.showDetails && <Grid.Row>
                <Grid.Column width={2}><Form.Input value={this.props.visitTenantName} onChange={(e) => { this.props.handleDataChange(this.props.arrayIndex, e.target.value, "ttName") }} label="Tenant Name" /></Grid.Column>
                <Grid.Column width={2}><Form.Input value={this.props.visitTenantEmail} onChange={(e) => { this.props.handleDataChange(this.props.arrayIndex, e.target.value, "ttEmail") }} label="Tenant Email" /></Grid.Column>
                <Grid.Column width={2}><Form.Input value={this.props.visitTenantContact} onChange={(e) => { this.props.handleDataChange(this.props.arrayIndex, e.target.value, "ttContact") }} label="Tenant Contact" /></Grid.Column>
                {/* <Grid.Column  textAlign="center" width={2}><Form.Button type="button"  onClick={()=>{this.props.handleDataChange(this.props.arrayIndex, undefined, "ttConfirm")}} basic color={this.props.visitTTConfirmed? "green":"red"} label="TT Confirmed"><div style={{textAlign:"center"}}>{this.props.visitTTConfirmed? "Yes":"No"}</div></Form.Button></Grid.Column> */}
                <Grid.Column width={2}><Form.Input value={this.props.visitBranch} onChange={(e) => { this.props.handleDataChange(this.props.arrayIndex, e.target.value, "branch") }} label="Branch" /></Grid.Column>
                 <Grid.Column width={2}><Form.Input value={this.props.visitAccessNotes} onChange={(e) => { this.props.handleDataChange(this.props.arrayIndex, e.target.value, "access") }} label="Access" /></Grid.Column>
                <Grid.Column width={2}><Form.Input value={this.props.visitNotes} onChange={(e) => { this.props.handleDataChange(this.props.arrayIndex, e.target.value, "notes") }} label="Notes" /></Grid.Column>
                <Grid.Column width={2}><Form.Input value={this.props.visitConclusionNotes} onChange={(e) => { this.props.handleDataChange(this.props.arrayIndex, e.target.value, "conclusionNotes") }} label="Conclusion Notes" /></Grid.Column>

              </Grid.Row>

              }
              </Grid>
          </Form>
          </Segment>
)
  }
}

export default AddPropertyVisitInput


// WEBPACK FOOTER //
// ./src/views/property_visits/add_property_visit_input.js